import React from "react";
import styled from "styled-components";
import { Link } from 'react-router-dom';
import { breakpoints } from "../../utils/styles";

const List = styled.ul`
    display: flex;
    flex-direction: row;
    font-size: 1.75rem;
    font-weight: 500;
    gap: 1rem;
    justify-content: space-between;
    list-style: none;
    margin: 0 !important;
    padding: 0 !important;
    overflow-x: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE 10+ */

    &::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera */
    }

    body.theme-market & {
        font-size: 1.25rem;
        font-weight: 900;
        gap: 2em;
    }
    body.theme-platinum & {
        color: vaR(--disabled-text);
        font-size: 1.25rem;
        font-weight: 700;
        gap: 2em;
    }

    li {
        cursor: pointer;
        font-family: var(--ff-title);
        text-transform: uppercase;
        white-space: nowrap;

        &.selected {
            color: var(--primary);
        }
    }

    @media (min-width: ${breakpoints.desktop}px) {
        display: block;

        li {
            display: inline-block;
            margin-right: 2rem;

            &:hover {
                color: var(--primary);
            }
        }
    }
`;

const StyledLink = styled(Link)<{selected: boolean}>`
    color: var(--text-primary);

    ${props => props.selected && 'color: var(--primary);'}
`;

interface MenuItem {
    id: string | number;
    name: string;
    to?: string;
}

type Props = {
    items: MenuItem[];
    selectedId: string | number;
    onSelect?: (id: string | number) => void;
} & React.HTMLAttributes<HTMLUListElement>;

const Submenu: React.FC<Props> = ({
    items,
    selectedId = "",
    onSelect,
    ...props
}) => {
    const handleCategoryClick = (item: MenuItem) => {
        onSelect && onSelect(item.id);
    };

    return <>
        <List {...props}>
            {items.map((item) => {
                const selected = selectedId === item.id;
                return (
                    <li
                        key={item.id}
                        onClick={item.to ? undefined : () => handleCategoryClick(item)}
                        className={selected ? "selected" : ""}
                    >
                        {item.to
                            ? <StyledLink to={item.to} selected={selected}>{item.name}</StyledLink>
                            : item.name}
                    </li>
                )
            })}
        </List>
    </>;
};

export default Submenu;